'use client';

import React from 'react';
import { motion } from 'framer-motion';
import { PartnerPortalSection } from './components/partner/PartnerPortalSection';

export function PartnershipSection() {
  return (
    <div className="relative w-full h-full overflow-hidden">
      {/* Aurora Background Effect */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-1/3 left-1/3 w-96 h-96 bg-gradient-to-r from-eskerium-gold/20 to-orange-400/20 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-1/3 right-1/3 w-80 h-80 bg-gradient-to-l from-purple-500/15 to-eskerium-blue/15 rounded-full blur-3xl animate-pulse delay-1500" />
      </div>

      {/* No glass card wrapper - just padding */}
      <div className="relative w-full h-full p-8 overflow-y-auto">
        <motion.div 
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.6 }}
        >
          {/* Header with Gradient Text */}
          <div className="mb-8 px-6 md:px-12 lg:px-16">
            <h2 className="text-3xl font-bold mb-2">
              <span className="bg-gradient-to-r from-white to-slate-300 bg-clip-text text-transparent">Partnership</span>{' '}
              <span className="text-eskerium-gold">Portal</span>
            </h2>
            <p className="text-slate-400 max-w-2xl">
              Discover how a partnership with Eskerium can elevate your brand and
              products through our collaborative approach.
            </p>
          </div>

          {/* Integrated Partner Portal Section with inline animations */}
          <PartnerPortalSection />
        </motion.div>
      </div>
    </div>
  );
}